// src/data/encliticForms.js
// Spanische Wörter mit angehängten Pronomen (hacerlo, dímelo, siéntate) und Gerundien (comiendo):
// Grundformen, unter denen so ein Wort als bekannt gilt. Genutzt von der App (computeKnownRatio)
// und vom Prüfskript (scripts/vocab-pipeline/cloze-tenses.js liest die Datei direkt), deshalb ohne Importe.

export const ENCLITICS = ["me", "te", "se", "nos", "os", "lo", "la", "los", "las", "le", "les"];

/** Ohne Akzente und Tilde (está → esta, año → ano). */
export function deaccent(s) {
  return s.normalize("NFD").replace(/[̀-ͯ]/g, "");
}

/**
 * Mögliche Stämme ohne angehängte Pronomen, ohne Akzente: dímelo → [dime, di], llámeme → [llame, lla].
 * Leer, wenn keine Pronomen dran sind. Welcher Stamm passt, prüft der Aufrufer.
 */
export function stripEnclitics(word) {
  let w = deaccent(word);
  const stems = [];
  const sorted = ENCLITICS.slice().sort((a, b) => b.length - a.length);
  for (let round = 0; round < 2; round++) {
    let hit = null;
    for (const e of sorted) {
      if (w.length > e.length + 1 && w.endsWith(e)) {
        hit = e;
        break;
      }
    }
    if (!hit) break;
    w = w.slice(0, -hit.length);
    stems.push(w);
  }
  return stems;
}

/**
 * Grundformen, unter denen ein Wort bekannt sein kann, ohne Akzente: dime → di, esperándote → esperar,
 * comiendo → comer/comir. Für Wörter, die so nicht in den Daten stehen.
 */
export function baseCandidates(word) {
  const plain = deaccent(word);
  const out = [];
  const stems = stripEnclitics(word);
  [plain, ...stems].forEach((w) => {
    out.push(w);
    const m = w.match(/^(.+?)(ando|iendo|yendo)$/);
    if (m) (m[2] === "ando" ? ["ar"] : ["er", "ir"]).forEach((e) => out.push(m[1] + e));
  });
  stems.forEach((x) => out.push(x + "s", x + "d")); // vámonos → vamos, sentaos → sentad
  return out;
}
